import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const drawerDefaultVariants = {
  "side": "left"
}
const drawerCompoundVariants = []

const drawerSlotNames = [
  [
    "root",
    "drawer__root"
  ],
  [
    "trigger",
    "drawer__trigger"
  ],
  [
    "portal",
    "drawer__portal"
  ],
  [
    "overlay",
    "drawer__overlay"
  ],
  [
    "content",
    "drawer__content"
  ],
  [
    "close",
    "drawer__close"
  ],
  [
    "title",
    "drawer__title"
  ],
  [
    "description",
    "drawer__description"
  ],
  [
    "header",
    "drawer__header"
  ],
  [
    "footer",
    "drawer__footer"
  ],
  [
    "body",
    "drawer__body"
  ]
]
const drawerSlotFns = /* @__PURE__ */ drawerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, drawerDefaultVariants, getSlotCompoundVariant(drawerCompoundVariants, slotName))])

const drawerFn = memo((props = {}) => {
  return Object.fromEntries(drawerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const drawerVariantKeys = [
  "side",
  "size"
]
const getVariantProps = (variants) => ({ ...drawerDefaultVariants, ...compact(variants) })

export const drawer = /* @__PURE__ */ Object.assign(drawerFn, {
  __recipe__: false,
  __name__: 'drawer',
  raw: (props) => props,
  variantKeys: drawerVariantKeys,
  variantMap: {
  "side": [
    "left",
    "right"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, drawerVariantKeys)
  },
  getVariantProps
})